import { StrictDict } from 'utils';
import api from './api';
import urls from './urls';

export default StrictDict({
  api,
  urls,
});
